import requestFunctions from "../../functions/requestFunctions";

export const state = {
  DOCUMENTS_ITEM: {},
  DOCUMENTS_LIST: [],
  DOCUMENTS_TABLE_DATA: [],
  DOCUMENTS_TOTAL_ROWS: 0
}

export const getters = {
  GET_DOCUMENTS_ITEM: (state) => {
    return state.DOCUMENTS_ITEM;
  },
  GET_DOCUMENTS_LIST: (state) => {
    return state.DOCUMENTS_LIST;
  },
  GET_DOCUMENTS_TABLE_DATA: (state) => {
    return state.DOCUMENTS_TABLE_DATA;
  },
  GET_DOCUMENTS_TOTAL_ROWS: (state) => {
    return state.DOCUMENTS_TOTAL_ROWS;
  }
}

export const mutations = {

  UPDATE_DOCUMENTS_ITEM(state, item) {
    state.DOCUMENTS_ITEM = item;
  },

  UPDATE_DOCUMENTS_LIST(state, list) {
    state.DOCUMENTS_LIST = list.data;
    state.DOCUMENTS_TABLE_DATA = [];

    state.DOCUMENTS_TOTAL_ROWS = list.total;
    list = list.data;

    list.forEach(el => {
      state.DOCUMENTS_TABLE_DATA.push({
        'created_at' : el.created_at,
        'number'     : el.number,
        'name'       : el.name,
        'company_name'    : el.company_name ? el.company_name : '-',
        'sum'        : el.sum,
        'uuid'       : el.uuid,
      });
    });
  },
}


export const actions = {

  async FETCH_DOCUMENTS_ITEM({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/documents/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_DOCUMENTS_ITEM', response.data);
      return response.data;
    }

  },

  async FETCH_DOCUMENTS_LIST({ commit }, payload= {}) {

    let query_url = 'https://api.client.za-bota.com/v1/documents';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_DOCUMENTS_LIST', response.data);
      return response.data;
    }

  },

  async FETCH_DOCUMENTS_CREATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/documents';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_DOCUMENTS_UPDATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/documents/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_DOCUMENTS_DELETE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/documents/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'DELETE');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

}